import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202511: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202511",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-11-01",
  endDate: "2025-11-30",
  impressions: 28093,
  clicks: 477,
  adsSpendDollars: 2094,
  budgetDollars: 15000,
  salesDollars: 14826,
  bestEstimateRoas: 7.08,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.14,
  newCustomersAcquired: 16,
  reorderConversions: 11,
  dataAvailableAtDate: "2025-12-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
